import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { SCAM_DATA } from '@/data/essentials_b';

export default function ScamsCard({ countryCode, countryName }) {
  const cc = (countryCode || '').toUpperCase();
  const list = (SCAM_DATA[cc] || SCAM_DATA.default || []).slice(0, 4);
  if (!list.length) return null;
  return (
    <div className="puvio-card p-5" data-testid="scams-card">
      <div className="flex items-start justify-between">
        <div>
          <p className="font-bold text-[11px] uppercase tracking-[0.22em] text-[var(--puvio-coral-deep)]">Common scams</p>
          <p className="text-xs text-[var(--puvio-text-2)] mt-0.5 font-medium">{countryName || 'Watch-outs here'}</p>
        </div>
        <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: '#FCE4E4' }}>
          <ShieldAlert className="w-6 h-6 text-[var(--puvio-coral-deep)]" />
        </div>
      </div>
      <ul className="mt-4 space-y-3">
        {list.map((s, i) => (
          <li key={i} className="rounded-2xl bg-[var(--puvio-bg-soft)] border border-[var(--puvio-border)] p-3" data-testid={`scam-${i}`}>
            <p className="text-sm font-extrabold text-[#0F1A13]">{s.title}</p>
            <p className="text-[12px] text-[var(--puvio-text-2)] mt-1 leading-relaxed">{s.desc}</p>
            <p className="mt-2 text-[12px] font-bold text-[var(--puvio-mint-deep)]">✓ {s.tip}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
